var _rect, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFr = function SvgIconFr(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0303 18.7822H12.0244V23H10.2949V13.0469H16.6182V14.4414H12.0244V17.4014H16.0303V18.7822ZM21.6494 19.165H19.7217V23H17.9922V13.0469H21.4922C22.6406 13.0469 23.527 13.3044 24.1514 13.8193C24.7757 14.3343 25.0879 15.0794 25.0879 16.0547C25.0879 16.7201 24.9261 17.2783 24.6025 17.7295C24.2835 18.1761 23.8369 18.5202 23.2627 18.7617L25.498 22.9111V23H23.6455L21.6494 19.165ZM19.7217 17.7773H21.499C22.0824 17.7773 22.5381 17.6315 22.8662 17.3398C23.1943 17.0436 23.3584 16.6403 23.3584 16.1299C23.3584 15.5967 23.2057 15.1842 22.9004 14.8926C22.5996 14.6009 22.1484 14.4505 21.5469 14.4414H19.7217V17.7773Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_fr.049eb7e9.svg";
export { ForwardRef as ReactComponent };